import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { loginUser } from '../../services/authService';
import { LoginUserResponse } from '../type';

interface UserState {
  data: LoginUserResponse | null;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: UserState = {
  data: null,
  status: 'idle',
};

export const userLogin = createAsyncThunk<
  any,
  any,
  { state: { user: UserState } }
>(
  'user/login',
  async (
    param: { email: string; password: string; loginType: string },
    { getState }
  ) => {
    const response = await loginUser(param);
    return response.data;
  }
);

export const userReducer = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<LoginUserResponse>) => {
      state.data = action.payload;
    },
    clearUserData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      });
  },
});

export const { updateUser, clearUserData } = userReducer.actions;

export const selectUser = (state: RootState) => state.user;

export default userReducer.reducer;
